import { Component, h, useRef } from "@lukekaalim/act";
import { html } from "@lukekaalim/act-web";

import classes from './Mini.module.css';
import { ID } from "@kosmod/kit";

export type LogicEditorProps = {
  name: string,
  active: boolean,
  enabled: boolean,

  onClickDelete(): void,
  onSetEnabled(enabled: boolean): void,
}

export const LogicEditor: Component<LogicEditorProps> = ({ name, enabled, onClickDelete, onSetEnabled, children, active }) => {
  const id = useRef(() => ID()).get();

  return h(html.li, { className: classes.miniTemplateLogicEntry, style: { opacity: active ? '1.0' : '0.6' } }, [
    h(html.div, { className: classes.miniTemplateLogicHeader }, [
      h(html.input, { id, type: 'checkbox', checked: enabled, onInput() { onSetEnabled(this.checked) }, }),
      h(html.strong, { className: classes.miniTemplateLogicName }, h(html.label, { htmlFor: id }, name)),
      h(html.button, { className: classes.miniTemplateLogicDeleteButton, type: 'button', onClick: onClickDelete }, 'Delete'),
    ]),

    children,
  ]);
}